import RegisterBusinessForm from './RegisterBusinessForm.jsx';

export default RegisterBusinessForm



// WEBPACK FOOTER //
// ./components/business/register-business-form/index.js